export default {
  ValidationToken: '',
  PaymentOptionId: '',
};
